import styled from 'styled-components'

export const MainContainer = styled.div`
  width: 100%;

  .meal-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
  }
  
  .ant-checkbox-inner, .ant-checkbox-input {
    transform: scale(1.5) translateX(-10%);
  }

  @media (min-width: 1000px) {
    width: 80%;
    margin: auto;
  }
  
  @media (min-width: 1300px) {
    width: 45%;
    margin: auto;
  }
`

export const MealOption = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 15px;
  border-radius: 10px;
  ${props => props.selected ? 'border: 1px solid #73BCAE' : 'border: 1px solid #d0d5dd'};
  box-shadow: 0 1px 2px rgba(16,24,40,.0509803922);
  cursor: pointer;
  transition: all 200ms ease-in-out;

  .option-content {
    display: flex;
    align-items: center;
    gap: 10px;

    .name {
      font-weight: bold;
    }

    .bordered-icon {
      background: white;
      padding: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      border: 2px solid #EFEFEF;

      img {
        border-radius: 10px;
      }
    }
    
    .icon {
      img {
        width: 50px;
      }
    }
  }
`
